import AccessControl from '../access-control';
import {SCHOOL_USER, SCHOOL_USER_ADMIN} from '../../../constants/user';

export default {
  'view': () => AccessControl.hasRole(SCHOOL_USER),
  'view-dashboard': () => AccessControl.hasRole(SCHOOL_USER),
  'view-vacancies': () => AccessControl.hasRole(SCHOOL_USER),
  'view-reports': () => AccessControl.hasRole(SCHOOL_USER),
  'view-admin': () => AccessControl.hasRole(SCHOOL_USER, SCHOOL_USER_ADMIN),
  'view-admin-school': (viewer, target) => AccessControl.hasRole(SCHOOL_USER, SCHOOL_USER_ADMIN, parseInt(target.schoolId, 10)),
  'view-school': (viewer, target) => AccessControl.hasRole(SCHOOL_USER, null, parseInt(target.schoolId, 10))
};


// WEBPACK FOOTER //
// ./src/services/access-control/permissions/schools.js